import React from 'react'
import Navbar from '../inc/Navbar'
import landsalephoto from "../images/LAND SALE.jpg";
import { Link } from "react-router-dom";
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import fourawater from "../images/Water Design.jpg";
import gate from "../images/main gate srg group.jpg";
import LogoSlider from './LogoSlider';


function LandSale() {
    return (
        <div>
            <Navbar />
            <br />
            <br />
            <br />
            <br />

            <div className='krishnagarland'>
                <div className="album py-1">
                    <div className="container mt-4">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li style={{ color: "white" }} className="breadcrumb-item"><Link to="/" style={{ color: "white" }}>Home</Link></li>
                                <li style={{ color: "white" }} className="breadcrumb-item active" aria-current="page">Land Sale</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>     
            <div style={{ color: "white", padding: "14px;", margin: 10 }} className="fixed-bottom "> <a style={{ color: "white" }} href="tel: 8918782294" className="srgcomplexkrishnagar" > <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-phone" viewBox="0 0 16 16">
        <path d="M11 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h6zM5 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H5z" />
        <path d="M8 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2z" />
      </svg> Call Us <div className="spinner-grow text-light spinner-grow-sm" role="status">
          <span className="visually-hidden"> Loading...</span>
        </div> </a></div>

            <br />
            <div className="album py-0">
                <div className="container">

                    <div className="card-body">
                        <div className='welcometext'>
                            <h1 style={{ color: "#B80000" }} className="card-title mb-0"><b> Premium Land <b>Availabe</b></b></h1>
                            <div className="col-md-2">
                                <hr style={{ color: "#1D4D93" }} />
                            </div>
                        </div>

                        <div className="album py-0">
                            <div className="container">
                                <div className="row">

                                    <div className="col-md-7 mt-3">
                                        <div className='mission'>
                                            <h3 style={{ color: "#1D4D93" }} className='mb-2'>Luxury Land <b>in Krishnagar</b></h3>
                                            <p style={{ color: "#1D4D93" }} className='mb-2'>Dear Visitors,</p>

                                            <p className='justify mb-2'>🏡 Land Sale (SRG Complex)</p>
                                            <p className='justify mb-1'>SRG Complex is a thoughtfully planned real estate development situated in a prime and well-connected location, offering an ideal blend of residential and commercial land use. The project is designed to provide modern infrastructure, accessibility, and long-term investment value.</p>

                                        </div>
                                    </div>
                                    <div className="col-md-5 mt-3">

                                        <img src={landsalephoto} className="card-img-top" alt="landsalephoto" />


                                    </div>





                                </div>
                            </div>
                        </div>
                        <br />






                    </div>
                </div>
            </div>

                <div className="album py-0">
                <div className="container">
                    <div className="row">

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>

                                                <img src={fourawater} className="card-img-top" alt="fourawater"/>

                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{color:"#030390"}} className="card-title mb-1">SRG COMPLEX </h5>
                                                <p style={{color:"#AD8816"}} className="card-text">Foura Water </p>
                                          

                                               
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={gate} className="card-img-top" alt="gate"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{color:"#030390"}}className="card-title mb-1">SRG COMPLEX </h5>
                                                <p  style={{color:"#AD8816"}} className="card-text">Main Gate</p>
                                                
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                  

                    </div>
                </div>
            </div>
            <LogoSlider/>
            <br/>
        </div>
    )
}

export default LandSale